<div trans>{{message}}</div>
<share-link-btns
  [showCopyBtn]="true"
  [link]="data.link"
  *ngIf="data.link"
></share-link-btns>
